import IEnumObject from "../interfaces/IEnumObject";

export default class Utility {
	public static generateClassName(componentName: string): string {
		return "practiq-booking-widget-" + componentName;
	}

	public static sortByAttribute<T extends {}>(
		a: T,
		b: T,
		key: keyof T
	): number {
		const aVal = a[key];
		const bVal = b[key];

		if (aVal > bVal) return 1;
		if (bVal > aVal) return -1;

		return 0;
	}

	public static getEnumValues(e: IEnumObject): string[] {
		return Object.values(e).filter((i: any) => typeof i === "string");
	}

	public static generateSelectId(label: string): string {
		return (
			"prompted-select-" +
			label.replace(new RegExp(" ", "g"), "-").toLowerCase()
		);
	}

	public static waveInterpolate(i: number) {
		return (r: number) =>
			`translate3d(0, ${
				15 * Math.sin(r + (i * 2 * Math.PI) / 1.6)
			}px, 0)`;
	}

	public static debug(message?: any, ...optionalParams: any[]): void {
		if (process.env.NODE_ENV !== "production") {
			console.log(message, optionalParams);
		}
	}

	public static scrollToTopOfElement(id: string, offset?: number): void {
		const element = window.document.getElementById(id) as HTMLElement;
		const documentRect = window.document.body.getBoundingClientRect();
		const top = element.getBoundingClientRect().top;
		const target = top - documentRect.top;
		// console.log(top);
		// console.log(target);
		offset = offset ? offset : 0;
		window.scrollTo(0, target + offset);
	}
}
